const vP18284 = require("./120.js");
const vLN1335 = 1335;
const vLN21522 = 21522;
const v14054 = vP18284.getBCHDigit(vLN1335);
exports.getEncodedBits = function (p18285, p18286) {
  const v14055 = p18285.bit << 3 | p18286;
  let v14056 = v14055 << 10;
  while (vP18284.getBCHDigit(v14056) - v14054 >= 0) {
    v14056 ^= vLN1335 << vP18284.getBCHDigit(v14056) - v14054;
  }
  return (v14055 << 10 | v14056) ^ vLN21522;
};